module.exports = __webpack_public_path__ + "fonts/b2bcaa52d04bde9a494fd954ef7e7e7b-Roboto-Medium.ttf";